import React, { PropTypes } from 'react';
import { hashHistory } from 'react-router'
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import ArchiveChooseTemplateModal from '../share/ArchiveChooseTemplateModal';
import { Modal} from 'antd';
const confirm = Modal.confirm;


export default class ArchiveChooseTemplatePage extends React.Component {

  constructor(props) {
    super(props);
    // set state
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      archiveId: props.location.query.archiveId,
      pageNumber: props.location.query.pageNumber,
      themes: [],
      choosedTemplate: {},
      showModal: false,
    };
    // bind this
    this.onCurrentRoleChange = this.onCurrentRoleChange.bind(this);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.chooseTemplate = this.chooseTemplate.bind(this);
    this.confirmHide = this.confirmHide.bind(this);
  }

  componentWillMount() {
    DataService.getAllThemes(this.state.archiveId).then(res => {
      this.setState({
        themes: res,
      })
    })
  }

  componentDidMount(){
    CurrentRoleStore.addChangeListener(this.onCurrentRoleChange);
  }

  componentWillUnmount(){
    CurrentRoleStore.removeChangeListener(this.onCurrentRoleChange);
  }

  onCurrentRoleChange() {
    this.setState({
      currentRole: CurrentRoleStore.getCurrentRole()
    });
  }

  showModal(e) {
    let {theme, template} = e.currentTarget.dataset;
    this.setState({
      showModal: true,
      choosedTemplate: this.state.themes[theme].templates[template]
    })
  }

  confirmHide(e){
    e.stopPropagation()
    let {theme, template} = e.currentTarget.dataset;
    let {themes} = this.state;
    let choosedTemplate = themes[theme].templates[template]
    let that = this
    confirm({
      title: '是否确定隐藏该模版？',
      onOk() {
        DataService.hideTemplate(choosedTemplate.id).then(res => {
          themes[theme].templates[template].is_deleted = true;
          that.setState({
            themes: themes
          })
        }).catch((error) => {
          console.log(error);
        });
      },
      onCancel() {
      },
    });
  }

  chooseTemplate(templateId, forParent) {
    let author = forParent ? 'parent' : 'teacher';
    DataService.createNewPage(this.state.archiveId, this.state.pageNumber, author, templateId).then(res => {
      hashHistory.goBack();
    })
  }

  hideModal() {
    this.setState({
      showModal: false,
      choosedTemplate: {}
    })
  }

  render() {
    let {currentRole} = this.state
    return (
      <div className="archive-choose-template-page">
        {this.state.themes.map((theme, index) => {
          return (
            <div className="theme-list" key={`theme-${index}`}>
              <div className="theme-title">{theme.title}</div>
              <div className="theme-description">{theme.description}</div>
              {theme.templates.map((template, indexTemplate) => {
                if(!template.is_deleted){
                  return (
                    <div key={`template-${index}-${indexTemplate}`} className="template-box" data-theme={index} data-template={indexTemplate} onClick={this.showModal}>
                      {currentRole.associatName=='system'&&<button className="hover-button" data-theme={index} data-template={indexTemplate} onClick={this.confirmHide}>隐藏</button>}
                      <div className={template.need_review ? 'review show' : 'review'}>需审核</div>
                      <div className="img-cover" style={{background: `url(${template.icon_url}) no-repeat`, backgroundSize: '4.5rem 4.5rem'}}></div>
                      <div className="template-title">{template.title}</div>
                      {template.used_count > 0 && <div className="used">已使用{template.used_count}次</div>}
                    </div>
                  )
                }
              })}
            </div>
          )
        })}
        <ArchiveChooseTemplateModal callBack={this.chooseTemplate} template={this.state.choosedTemplate} showModal={this.state.showModal} hideModal={this.hideModal} isChoose={true}/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/ArchiveChooseTemplatePage.jsx